import React from "react";
import { Box, Button, Flex, Heading, HStack, Icon, IconButton, Image, Spinner, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Logo from "../../../assets/Logo.svg";

const MotionBox = motion.create(Box);

export const editorInputProps = {
  h: "54px",
  rounded: "14px",
  bg: "public.bg.muted",
  color: "public.fg.default",
  borderColor: "transparent",
  _focus: { bg: "public.bg.panel", borderColor: "brand.red", boxShadow: "0 0 0 1px var(--chakra-colors-red-600)" },
};

export function EditorField({ label, hint, error, children }) {
  return <Box>
    <Text mb="2" fontSize="sm" fontWeight="700" color="public.fg.default">{label}</Text>
    {children}
    {(error || hint) && <Text mt="2" fontSize="xs" color={error ? "red.600" : "public.fg.subtle"}>{error || hint}</Text>}
  </Box>;
}

export default function FamiliaEditorLayout({ title, description, icon, children, onSave, saveLabel = "Guardar cambios", disabled, busy, backTo = "/perfil/familia", backLabel = "Volver" }) {
  const navigate = useNavigate();
  return <Flex minH="100dvh" direction="column" bg="public.bg.canvas" color="public.fg.default">
    <HStack as="header" px="5" pt="5" pb="3" justify="space-between">
      <IconButton aria-label={backLabel} variant="ghost" rounded="full" onClick={() => navigate(backTo)}><FiArrowLeft/></IconButton>
      <Image src={Logo} alt="Arawaks" boxSize="34px" objectFit="contain"/>
    </HStack>

    <MotionBox flex="1" px="5" pt="5" pb={onSave ? "110px" : "8"} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: .2 }}>
      <HStack gap="4" align="center">
        <Flex boxSize="50px" flexShrink="0" rounded="18px" bg="red.50" color="red.600" _dark={{ bg: "red.950", color: "red.300" }} align="center" justify="center"><Icon fontSize="23px">{icon}</Icon></Flex>
        <Box><Heading fontSize="30px" lineHeight="1.08">{title}</Heading>{description && <Text mt="1" color="public.fg.muted" fontSize="sm">{description}</Text>}</Box>
      </HStack>
      <Box mt="8">{children}</Box>
    </MotionBox>

    {onSave && <Box position="fixed" bottom="0" left="50%" transform="translateX(-50%)" w="full" maxW="720px" px="5" pt="3" pb="calc(16px + env(safe-area-inset-bottom))" bg="public.bg.canvas/94" backdropFilter="blur(12px)" borderTopWidth="1px" borderColor="public.border.subtle" zIndex="5">
      <Button w="full" h="54px" rounded="full" bg="brand.red" color="white" fontWeight="800" disabled={disabled || busy} onClick={onSave} _hover={{ bg: "red.700" }}>
        {busy ? <Spinner size="sm"/> : saveLabel}
      </Button>
    </Box>}
  </Flex>;
}
